// import { FIUU_LOGO_PATH } from '../constants/logo';

export default function Footer() {
  return (
    <footer className="py-4 text-center text-sm text-gray-500">
      <div className="mb-1 mt-2 flex items-center justify-center gap-2">
        {/* <span className="font-semibold text-gray-600">Payment via</span>
        <img
          src={FIUU_LOGO_PATH}
          alt="Fiuu"
          className="h-6 rounded bg-[#0047BA] py-1 pl-2"
        /> */}
        <span className="text-gray-600 text-xs font-semibold">Proudly Made in Southeast Asia ♥️</span>
      </div>
      © {new Date().getFullYear()} Aye Solutions. All rights reserved.
      <div className="flex items-center justify-center"></div>
    </footer>
  );
}
